import {EtsyListing, etsySettings} from '@coolcolduk/etsy';
import {padArray} from '@coolcolduk/util';
import dayjs from 'dayjs';
import {unescape} from 'lodash';
import {ETSY_SEO_CSV_HEADER} from './getEtsySeoCsvHeader';
import saveAsCsv from './saveAsCsv';

/**
 * create a csv to be downloaded
 * @param etsyListings
 */
export default async function downloadListingsAsCsvForBulkUpdate(etsyListings: EtsyListing[]) {
  const csvRows = etsyListings.map((listing) => [
    listing.listing_id.toString(),
    unescape(listing.title),
    ...padArray(listing.tags || [], '', etsySettings.listing.tags.maxCount, false).map(unescape),
    listing.num_favorers.toString(),
    listing.views.toString(),
    dayjs(listing.updated_timestamp * 1000).format('YYYY-MM-DD'),
  ]);

  const csvContent = [ETSY_SEO_CSV_HEADER, ...csvRows];
  saveAsCsv(csvContent, `etsy_listings_bulk_update_${dayjs().format('YYYY-MM-DD HH_mm_ss')}.csv`);
}
